import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Eğer kayıt sonrası otomatik login olacaksa

function RegisterPage() {
  const [companyName, setCompanyName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [taxNumber, setTaxNumber] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth(); // Kayıt sonrası otomatik login için

  const validate = () => {
    if (companyName.length < 2) return "Firma adı en az 2 karakter olmalı.";
    if (!/^[a-zA-Z0-9_.-]{3,}$/.test(username)) return "Kullanıcı adı en az 3 karakter olmalı ve sadece harf, rakam, _ . - içerebilir.";
    if (password.length < 3) return "Şifre en az 3 karakter olmalı.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errorMsg = validate();
    if (errorMsg) {
      setError(errorMsg);
      return;
    }
    try {
      const response = await fetch('https://www.irsaliye.bybello.com/backend/api/register.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          company_name: companyName,
          username,
          password,
          phone,
          address,
          tax_number: taxNumber,
        }),
      });
      const data = await response.json();

      if (data.success) {
        setMessage('Kayıt başarılı! Giriş yapılıyor...');
        // Kayıt sonrası otomatik giriş
        const loginResult = await login(username, password);
        if (loginResult.success) {
          navigate('/dashboard');
        } else {
          setMessage('Kayıt başarılı ancak otomatik giriş başarısız: ' + (loginResult.error || 'Bilinmeyen bir hata oluştu.'));
        }
      } else {
        setMessage(data.error || 'Kayıt başarısız.');
      }
    } catch (error) {
      console.error('Kayıt sırasında hata:', error);
      setMessage('Ağ hatası veya sunucu bağlantı sorunu.');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">Yeni Hesap Oluştur</div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Firma Adı</label>
                  <input type="text" className="form-control" value={companyName} onChange={(e) => setCompanyName(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Kullanıcı Adı</label>
                  <input type="text" className="form-control" name="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Şifre</label>
                  <input type="password" className="form-control" name="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Telefon (Opsiyonel)</label>
                  <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Adres (Opsiyonel)</label>
                  <input type="text" className="form-control" value={address} onChange={(e) => setAddress(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Vergi Numarası (Opsiyonel)</label>
                  <input type="text" className="form-control" value={taxNumber} onChange={(e) => setTaxNumber(e.target.value)} />
                </div>
                <button type="submit" className="btn btn-success w-100">Kayıt Ol</button>
                {message && <div className="alert alert-info mt-3">{message}<br/></div>}
                {error && <div className="alert alert-danger mt-3">{error}</div>}
              </form>
              <p className="mt-3 text-center">
                Zaten hesabın var mı? <a href="/login">Giriş Yap</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
